import React from "react";
import Connect from "../../../assets/svg/connect.svg";
import OutlookIcon from "../../../assets/svg/outlook.svg";
import SmokeballIcon from "../../../assets/svg/smokeball.svg";
import { MessageContainer, Severity } from "../Message/MessageContainer";

export type TProps = {
  title?: string;
  message?: string;
  isLoading?: boolean;
  severity?: Severity;
  onlyShowMessageIfIsLoading?: boolean;
};

export const LoadingPresentational = (props: TProps) => {
  let showMessage = props.title && props.message ? true : false;
  const connectClassName = props.isLoading === true ? "animate-spin" : "";

  if (props.onlyShowMessageIfIsLoading) {
    showMessage = showMessage && props.isLoading === true;
  }

  return (
    <div className="flex flex-col items-center justify-center flex-1">
      <div className="flex items-center justify-center">
        <img className="w-16 h-16" src={OutlookIcon} alt="Save Outlook emails" />
        <img className={`w-12 h-12 mx-6 align-middle ${connectClassName}`} src={Connect} alt="to" />
        <img className="w-16 h-16" src={SmokeballIcon} alt="Smokeball" />
      </div>
      {showMessage === true && props.title && (
        <MessageContainer
          className="mx-4 mt-8"
          title={props.title}
          severity={props.severity ?? Severity.Information}
          content={props.message ?? props.title}
        />
      )}
    </div>
  );
};
